import { DecorationTagButton } from './decoration-tag-button';

export const EmojiButton = () => {
	return <DecorationTagButton tag="emoji" />;
};
